var hasAcceptedPerformance = function () {
    return ICF.Utils.Consent.CookieContainsPattern(ICF.Variables.ConsentGroupPatterns.AcceptedPerformance)
};

module.exports = hasAcceptedPerformance;